import { createApp } from 'vue'
import App from './App.vue'
import i18n, { applyLanguage, getStoredLanguage } from '@/i18n'
import reveal from '@/plugins/reveal'
import '@/scss/main.scss'

// hydrate the persisted language before the first paint
applyLanguage(getStoredLanguage())

createApp(App)
	.use(i18n)
	.use(reveal)
	.mount('#app')
